import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setLogout } from '../../Auth/LoginSlice';
import { setActiveKey } from '../ActiveKeySlice';
import { useNavigate } from 'react-router-dom';


const UseCourseList = (token, setLoader) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [courseList, setCourseList] = useState([]);

    const getAllCourse = async () => {
        try {
            setLoader(true);
            const response = await fetch(process.env.REACT_APP_BASE_URL + '/priority/titleTypeFilter', {
                method: 'POST',
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({
                    type: "Course",
                })
            })
            const responseData = await response.json();
            if (responseData.message === "Authorization failed / Forbidden") {
                setLoader(true);
                dispatch(setLogout(null));
                dispatch(setActiveKey(null));

                localStorage.removeItem('persist:root');
                navigate('/');
            } else {
                setCourseList(responseData?.data);
                setLoader(false);
            }
        } catch (Err) {
            console.log("Err while getting activites", Err);
            setLoader(false);
        }
    }


    return { courseList, getAllCourse }
}

export default UseCourseList